import { makeStyles } from '@mui/styles';
import { Col, Row } from 'antd';
import { clsx } from 'clsx';
import { Button } from '@mui/material';
import { CreditMoneyType } from '@types';
import { InfoTooltip, InitialCard } from '@components';
import { moneyFormatter } from '@utils';

export interface Amount {
  title: string;
  amount: number;
  group: CreditMoneyType;
  tooltip?: string;
  unclickable?: boolean;
  isUsd?: boolean;
}

interface AmountWidgetProps {
  amounts: Amount[];
  group: string | undefined;
  changeGroup: (group: CreditMoneyType) => void;
}

export const AmountsWidget = ({ amounts, changeGroup, group }: AmountWidgetProps) => {
  const cls = useStyles();

  return (
    <InitialCard autoHeight extraPadding wrapperClass={cls.wrap}>
      <div className={cls.box}>
        <Row gutter={[15, 15]}>
          {amounts.map(amount => (
            <Col className={cls.col} key={amount.title} xs={12} sm={8} md={4}>
              {amount.tooltip && <InfoTooltip title={amount.tooltip} className={cls.tooltip} />}
              <Button
                className={clsx(cls.groupBtn, amount.group === group && cls.groupSelected)}
                onClick={amount.unclickable ? undefined : () => changeGroup(amount.group)}
              >
                <div className={cls.title}>{amount.title}</div>
                <div className={cls.money}>
                  {moneyFormatter.format(amount.amount)}{amount.isUsd && ' USD'}
                </div>
              </Button>
            </Col>
          ))}
        </Row>
      </div>
    </InitialCard>
  );
};

const useStyles = makeStyles({
  wrap: {
    margin: '0 auto',
  },
  box: {
    fontFamily: 'var(--font-primary)',
  },
  col: {
    position: 'relative',
  },
  groupBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 'calc(100% - 8px)',
    marginLeft: 6,
    textTransform: 'none',
    color: 'var(--text-color)',
  },
  groupSelected: {
    backgroundColor: 'var(--primary-color) !important',
    color: 'white !important',
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
  },
  money: {
    fontSize: 15,
    fontWeight: 400,
  },
  tooltip: {
    position: 'absolute',
    top: -10,
    left: -10,
    zIndex: 10,
  },
});
